import { createQuery } from '../../utils';
import { ChartDataProps, createMockChartData } from '@hum/types';

export const getChartsData = createQuery<ChartDataProps>(
  () => Promise.resolve(createMockChartData()),
  {
    scope: 'chart',
  }
);
